// Single source of truth for the membership feature list shown on both the
// /membership/plans cards and the signup onboarding membership picker.
export const MEMBERSHIP_FEATURES = [
    "Search jobs",
    "Manage job tasks",
    "Career Success Analysis",
    "Resume Review",
    "Mock Interview",
    "Job alerts",
    "Share goals with coach",
];

// Which features are included for a tier, keyed by its ascending-price index
// (cheapest = 0). Returns an array aligned with MEMBERSHIP_FEATURES of
// { included, badge? } — badge is a short qualifier ("Summary", "Trial") shown
// next to a feature that's included but limited on that tier.
export function getFeaturesForTier(tierIndex) {
    if (tierIndex === 0) {
        return [
            { included: true },                              // Search jobs
            { included: true },                               // Manage job tasks
            { included: true, badge: "Summary" },              // Career Success Analysis
            { included: true, badge: "Trial" },                // Resume Review
            { included: true, badge: "Trial" },                // Mock Interview
            { included: false },                               // Job alerts
            { included: false },                               // Share goals with coach
        ];
    }
    return MEMBERSHIP_FEATURES.map(() => ({ included: true })); // everything else: all features, no limits
}

// The Career Success Analysis line follows what the tier really unlocks (Edit
// Tier > Unlocks features: csi_recommendations): the full report, or the summary.
// Without FeatureKeys from the API the list stays as it was.
export function withTierAccess(features, tier) {
    if (!Array.isArray(tier?.FeatureKeys)) return features;
    const i = MEMBERSHIP_FEATURES.indexOf("Career Success Analysis");
    const out = features.slice();
    out[i] = tier.FeatureKeys.includes("csi_recommendations") ? { included: true } : { included: true, badge: "Summary" };
    return out;
}
